import React from 'react';
import { Row, Col } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { UnpaidFeeResultForm } from './../../components';
import { getSearchActionResponse, getUnpaidFees } from './../../selectors/Search';
import { clearActionResponse } from './../../actions/Global';

class Bulletin extends React.Component {
  render() {
    return (
      <Row>
        <Col span={24}>
          <UnpaidFeeResultForm unpaidFees={this.props.unpaidFees} />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{unpaidFees, error}}
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    unpaidFees: getUnpaidFees(state),
    searchActionResponse: getSearchActionResponse(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{unpaidFees: shim, error: shim, clearActionResponse: shim}}
 */
Bulletin.propTypes = {
  unpaidFees: PropTypes.instanceOf(List),
  error: PropTypes.object,
  clearActionResponse: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Bulletin);
